import React from 'react'

export const EnvelopeIcon: React.FC = () => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" width="32" height="32">
    <defs>
      <path
        id="envelope_icon_a"
        d="M15.697 4.362c.122-.096.303-.006.303.147V10.9c0 .828-.672 1.5-1.5 1.5h-13c-.828 0-1.5-.672-1.5-1.5V4.512c0-.156.178-.243.303-.146.7.543 1.628 1.234 4.816 3.55.66.48 1.772 1.493 2.881 1.487 1.116.01 2.25-1.025 2.884-1.487 3.188-2.316 4.113-3.01 4.813-3.554zM8 8.4c.725.013 1.769-.912 2.294-1.294 4.147-3.01 4.462-3.272 5.418-4.022.182-.14.288-.359.288-.59V1.9c0-.828-.672-1.5-1.5-1.5h-13C.672.4 0 1.072 0 1.9v.594c0 .231.106.447.287.59.957.747 1.272 1.013 5.42 4.022C6.23 7.488 7.274 8.413 8 8.4z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h32v32H0z" />
      <g transform="translate(8 10)">
        <mask id="envelope_icon_b" fill="#fff">
          <use xlinkHref="#envelope_icon_a" />
        </mask>
        <g fill="#9A8B88" mask="url(#envelope_icon_b)">
          <path d="M-1.6-3.2h19.2V16H-1.6z" />
        </g>
      </g>
    </g>
  </svg>
)
